import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="Why Wearing Busy as a Badge of Honor is Bulls#!t article by Kat Medina, author of the book, The Joys of Jet Lag. An article about time management, priorities, and why being too busy is ruining your life and wasting your time." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Right now, we’re facing a cultural pandemic and I’m not talking about coronavirus.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Busy has become a modern-day dick-measuring contest. Everyone is trying to one-up each other with tales of all the crap they have going on in their lives. Who’s busier? Whose life is crazier? Who has more problems? We feel significant and important if we win. But winning the busy contest is like winning a 72 oz. steak challenge at a restaurant–you manage to smash all that meat down your face-hole in under an hour and end up feeling both proud and shitty at the same damn time.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Let me ask you a question. When was the last time you heard yourself or someone you know say, “busy, but good” in response to the generic small talk question of how are you doing? It sounds cooler and more important than just “good” and I’m certainly guilty of this. It became a habit for a while actually.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'It generally starts off innocently enough. You’re slammed with work and life and are officially busy AF. A friend checks in and when you tell them all that you have going on, you get some empathetic encouragement. It feels overwhelming at first, and you long for a stress-free life with no obligations. But we are very adaptable as humans and when most of us feel the pressure, we transform our soft shitty mindset into efficient, high-performance diamonds.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Even though things are crazy, you feel productive as you make progress. You manage to pull off all the tasks and only pop out a few grey hairs in the process. Bravo! A sense of relief and accomplishment ensues. And then what?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'When we no longer have a giant serving of spaghetti and stress-balls on our plate, the novelty of being able to breathe and relax feels fantastic. It doesn’t last long though. You’ve changed. After having accomplished so much during your crazy-busy time, you feel like something is missing. You ask a friend how they are doing and they respond, “busy, but good.” You question if you should be doing something more, feeling as though your value is tied to how busy you are. So you start to take on more and the cycle begins again. You may be stressed, but at least you feel like you’re doing something important.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'We wear busy as a badge of honor.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'My concern is that we are confusing a packed schedule with purpose. When we are so busy that we can’t spend time with our family or friends, is that really something to be proud of? If we have so much to do that we never have time to do what we love, do we deserve the feeling of significance it gives us?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'We’ve all heard the workplace recommendation to say yes to every opportunity because we never know where it might lead us. Sage advice for someone who has an infinite amount of time. But for the rest of us? You need to prioritize. Not all opportunities are created equal and sometimes you need to say no to the good so that you can say yes to the great.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'What if we used this uncertain time of daytime jammies and facemasks to figure out what we really want and prioritize the things that are important to us?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'If it’s been a while since you’ve sat with yourself without distraction and honestly asked what you want in this life, do it today. Give yourself 30 minutes to figure out what is most important to you and what you want to accomplish before you croak. Then, evaluate everything you are currently juggling. How many of those tasks are getting you more of what you value? Lastly, ask yourself the tough question of why you are doing all of those things.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Why are you taking on so much?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Is it because you need the money so that you can eat or pay rent? Is it because you fear if you say no then you will be irrelevant in the workplace? Is it because it makes you feel important and respected? Is it because you are distracting yourself from the fact that you don’t know what you want in life and are unhappy?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Be honest with yourself. Take a truthful look at everything that you are doing and figure out which tasks are taking you closer to what’s important to you, and which are just eating away at your limited time without adding any value.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'If you start to say no to the time-suck tasks that don’t take you closer to your goals or values, you will create space for the things you actually care about.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Time is not a renewable resource. It’s finite and is one of the most valuable assets we have. Guard it with your life, because if you don’t, that’s exactly what it will cost you.'}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/busy.js